import { BaseModel } from '../../_base/crud';

export class MasterEntity extends BaseModel {
  uuid: string;
  category: string;
  width: number;
  height: number;
  depth: number;
  thickness: string;
  orderCode: string;
  type: string;
  price: number;
  itemDescription: string;
  typeCode: string;
  unitofMasure: string;
  color: string;
  numberPerPack: number;
  unitWeight: number;
  description: string;
  remark: string;
  assemblyTime: number;

  clear(): void {
    this._id = '';
    this.category = '';
    this.width = 0;
    this.height = 0;
    this.depth = 0;
    this.thickness = '';
    this.price = 0;
    this.type = '';
    this.orderCode = '';
    this.itemDescription = '';
    this.typeCode = '';
    this.unitofMasure = '';
    this.color = '';
    this.numberPerPack = 0;
    this.unitWeight = 0;
    this.description = '';
    this.remark = '';
    this.assemblyTime = 0;
  }
}
